<div class="main-container" *ngIf="!isMobile">
  <div class="viewer">
    <iframe [src]="safeUrl" frameborder="0" width="100%" height="100%"></iframe>
  </div>
  <div class="report">
    <div class="des-box">
      <nz-descriptions nzTitle="检查报告" [nzColumn]="2" nzBordered [nzSize]="'small'">
        <nz-descriptions-item nzTitle="患者姓名">{{ caseInfo.patientName }}</nz-descriptions-item>
        <nz-descriptions-item nzTitle="患者年龄">{{ caseInfo.patientAge }}Y</nz-descriptions-item>
        <nz-descriptions-item nzTitle="患者性别">{{ caseInfo.patientGender }}</nz-descriptions-item>
        <nz-descriptions-item nzTitle="患者编号">{{ caseInfo.patientId }}</nz-descriptions-item>
        <nz-descriptions-item nzTitle="检查部位">{{ caseInfo.bodyPartExamined }}</nz-descriptions-item>
        <nz-descriptions-item nzTitle="申请科室">{{ caseInfo.applyDepartment }}</nz-descriptions-item>
        <nz-descriptions-item nzTitle="检查类型">{{ caseInfo.deviceType }}</nz-descriptions-item>
        <nz-descriptions-item nzTitle="床号">{{ caseInfo.bedNumber }}</nz-descriptions-item>
        <nz-descriptions-item nzTitle="影像学描述" [nzSpan]="2">{{ caseInfo.reportDescribe }}</nz-descriptions-item>
        <nz-descriptions-item nzTitle="影像学建议" [nzSpan]="2">{{ caseInfo.reportDiagnose }}</nz-descriptions-item>
      </nz-descriptions>
    </div>
  </div>
</div>
<div class="mobile-container" *ngIf="isMobile">
  <div class="tabs">
    <div class="tab" [ngClass]="type === 0 ? 'active' : ''" (click)="type = 0">影像</div>
    <div class="tab" [ngClass]="type === 1 ? 'active' : ''" (click)="type = 1">报告</div>
  </div>
  <div class="main">
    <div class="viewer" [ngClass]="{ hidden: type === 1 }">
      <iframe [src]="safeUrl" frameborder="0" width="100%" height="100%"></iframe>
    </div>
    <div class="report" [ngClass]="{ hidden: type === 0 }">
      <div class="des-box">
        <nz-descriptions nzTitle="检查报告" [nzColumn]="1" nzBordered [nzSize]="'small'">
          <nz-descriptions-item nzTitle="患者姓名">{{ caseInfo.patientName }}</nz-descriptions-item>
          <nz-descriptions-item nzTitle="患者年龄">{{ caseInfo.patientAge }}Y</nz-descriptions-item>
          <nz-descriptions-item nzTitle="患者性别">{{ caseInfo.patientGender }}</nz-descriptions-item>
          <nz-descriptions-item nzTitle="患者编号">{{ caseInfo.patientId }}</nz-descriptions-item>
          <nz-descriptions-item nzTitle="检查部位">{{ caseInfo.bodyPartExamined }}</nz-descriptions-item>
          <nz-descriptions-item nzTitle="申请科室">{{ caseInfo.applyDepartment }}</nz-descriptions-item>
          <nz-descriptions-item nzTitle="检查类型">{{ caseInfo.deviceType }}</nz-descriptions-item>
          <nz-descriptions-item nzTitle="床号">{{ caseInfo.bedNumber }}</nz-descriptions-item>
          <nz-descriptions-item nzTitle="影像学描述" [nzSpan]="2">{{ caseInfo.reportDescribe }}</nz-descriptions-item>
          <nz-descriptions-item nzTitle="影像学建议" [nzSpan]="2">{{ caseInfo.reportDiagnose }}</nz-descriptions-item>
        </nz-descriptions>
      </div>
    </div>
  </div>
</div>
<!-- 遮罩层 -->
<div class="mask" *ngIf="showMask">
  <div class="base">
    <!-- 校验验证码 -->
    <div class="verify-code">
      <div class="logo">
        <img src="assets/logo.png" alt="logo" />
      </div>
      <div class="tips">
        <div class="text">该链接启用了验证码，请输入验证码查看。</div>
      </div>
      <!-- <div class="title">请输入验证码</div> -->
      <div class="content">
        <input nz-input nzSize="large" [(ngModel)]="verifyCode" placeholder="请输入验证码" />
      </div>
      <div class="btns">
        <button nz-button nzType="primary" (click)="confirmVerifyCode()" nzBlock>确定</button>
      </div>
    </div>
  </div>
</div>
